import Link from 'next/link';
import { LogoSolid } from '@/components/Logo';

const linkClass = 'text-ink-muted hover:text-ink transition-colors';
const headingClass = 'text-[12px] font-medium text-ink mb-3';

export default function SiteFooter() {
  return (
    <footer className="border-t border-cream-200 bg-cream-50">
      {/* Link grid */}
      <div className="max-w-[960px] mx-auto px-6 pt-12 pb-8 text-[13px]">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-8 sm:gap-10">
          <div>
            <p className={headingClass}>Product</p>
            <ul className="space-y-2">
              <li><Link href="/" className={linkClass}>Converter</Link></li>
              <li><Link href="/pricing" className={linkClass}>Pricing</Link></li>
              <li><Link href="/examples" className={linkClass}>Examples</Link></li>
            </ul>
          </div>

          <div>
            <p className={headingClass}>Convert</p>
            <ul className="space-y-2">
              <li><Link href="/png-to-svg" className={linkClass}>PNG to SVG</Link></li>
              <li><Link href="/jpg-to-svg" className={linkClass}>JPG to SVG</Link></li>
              <li><Link href="/webp-to-svg" className={linkClass}>WebP to SVG</Link></li>
              <li><Link href="/image-to-svg" className={linkClass}>Image to SVG</Link></li>
              <li><Link href="/vs" className={linkClass}>Compare</Link></li>
            </ul>
          </div>

          <div>
            <p className={headingClass}>Use cases</p>
            <ul className="space-y-2">
              <li><Link href="/cricut" className={linkClass}>Cricut &amp; Silhouette</Link></li>
              <li><Link href="/laser" className={linkClass}>Laser Cutting</Link></li>
              <li><Link href="/screen-printing" className={linkClass}>Screen Printing</Link></li>
              <li><Link href="/etsy-svg" className={linkClass}>SVG Files for Etsy</Link></li>
            </ul>

            <p className={`${headingClass} mt-8`}>Free SVG tools</p>
            <ul className="space-y-2">
              <li><Link href="/svg-viewer" className={linkClass}>SVG Viewer</Link></li>
              <li><Link href="/svg-to-react" className={linkClass}>SVG to React</Link></li>
              <li><Link href="/svg-to-data-uri" className={linkClass}>SVG to Data URI</Link></li>
            </ul>
          </div>

          <div>
            <p className={headingClass}>Exports</p>
            <ul className="space-y-2">
              <li><Link href="/image-to-pdf" className={linkClass}>Image to PDF</Link></li>
              <li><Link href="/image-to-dxf" className={linkClass}>Image to DXF</Link></li>
              <li><Link href="/image-to-eps" className={linkClass}>Image to EPS</Link></li>
            </ul>

            <p className={`${headingClass} mt-8`}>More from us</p>
            <ul className="space-y-2">
              <li><a href="https://coloringmoon.com" className={linkClass}>Coloring Moon</a></li>
            </ul>
          </div>

          <div>
            <p className={headingClass}>Resources</p>
            <ul className="space-y-2">
              <li><Link href="/developers" className={linkClass}>API Docs</Link></li>
              <li><Link href="/ai" className={linkClass}>AI Agents</Link></li>
              <li><Link href="/claude-code" className={linkClass}>Claude Code skill</Link></li>
              <li><Link href="/mcp" className={linkClass}>MCP server</Link></li>
              <li><Link href="/tutorials" className={linkClass}>Tutorials</Link></li>
              <li><Link href="/blog" className={linkClass}>Blog</Link></li>
              <li><Link href="/privacy" className={linkClass}>Privacy</Link></li>
              <li><Link href="/terms" className={linkClass}>Terms</Link></li>
              <li><a href="mailto:contact@svg.new" className={linkClass}>Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-cream-200 flex items-center justify-between font-mono text-[11px] text-ink-faint">
          <span className="group flex items-center gap-2">
            <LogoSolid className="w-7 !gap-0 [&>svg]:block text-ink opacity-60 group-hover:opacity-100 transition-opacity duration-200" />
            <span>svg.new &copy; {new Date().getFullYear()}</span>
          </span>
        </div>
      </div>
    </footer>
  );
}
